var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSms = function SvgSms(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 18-2.3 2.3q-.476.475-1.088.212Q2 20.25 2 19.575V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h16q.824 0 1.413.587Q22 3.176 22 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm-.85-2H20V4H4v13.125zM8 11q.424 0 .713-.287A.97.97 0 0 0 9 10a.97.97 0 0 0-.287-.713A.97.97 0 0 0 8 9a.97.97 0 0 0-.713.287A.97.97 0 0 0 7 10q0 .424.287.713Q7.576 11 8 11m4 0q.424 0 .713-.287A.97.97 0 0 0 13 10a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 9a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 10q0 .424.287.713.288.287.713.287m4 0q.424 0 .712-.287A.97.97 0 0 0 17 10a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 9a.97.97 0 0 0-.713.287A.97.97 0 0 0 15 10q0 .424.287.713.288.287.713.287"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSms);
export { ForwardRef as ReactComponent };